import React, {useEffect, useRef, useState} from "react";
import {Button} from "../../common/Button";
import {BiTime} from "react-icons/bi";
import {calculatePrediction} from "../WeightPrediction";
import {useFunnel} from "../../../context/FunnelContext";
import {plans} from "../../../config/payment";
import {AppStoreRating} from "./Rating";
import {CustomerReviews} from "./Review";
import {DietComparison} from "./Compare";
import {MoneyBackGuarantee} from "./MoneyBack";
import {ResearchInfo} from "./ResearchInfo";
import {WeightGoalGraph} from "./WeightGoal";
import {PlanCard} from "./PlanCard";
import {PaymentSection} from "./Checkout";

export function Paywall() {
    const paymentSectionRef = useRef(null);

    // Add scroll function
    const scrollToPayment = () => {
        paymentSectionRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
        });
    };

    const [selectedPlan, setSelectedPlan] = useState(plans[0].id);

    const {state} = useFunnel();
    const prediction = calculatePrediction(state.userData);

    const dataPoints = [
        {month: "Now", weight: prediction.currentWeight},
        {
            month: prediction.targetDate.toLocaleDateString("en-US", {
                month: "short",
            }),
            weight: prediction.goalWeight,
        },
    ];
    return (
        <div className="min-h-screen">
            <div className="px-4 py-6">
                <div className="text-center mb-6">
                    {/* Graph Section */}
                    <WeightGoalGraph dataPoints={dataPoints} prediction={prediction}/>
                    <h1 className="text-2xl font-bold my-10">
                        Grab your Personal Plan before it's gone!
                    </h1>
                    <div className="bg-gradient-to-r from-orange-500 to-orange-600 p-3 rounded-xl shadow-lg">
                        <div className="flex items-center justify-center space-x-2 text-white">
                            <BiTime className="text-2xl animate-pulse"/>
                            <span className="font-semibold">
                Special offer ends in <Timer/> minutes
              </span>
                        </div>
                    </div>
                </div>
                <div className="space-y-4">
                    {plans.map((plan) => (
                        <PlanCard
                            key={plan.id}
                            plan={plan}
                            isSelected={selectedPlan === plan.id}
                            onClick={() => setSelectedPlan(plan.id)}
                        />
                    ))}
                </div>
                <ResearchInfo/>
                <Button onClick={scrollToPayment} className="w-full mt-6">
                    Get my plan
                </Button>
                <AppStoreRating/>
                <DietComparison/>
                <CustomerReviews/>
                <Button onClick={scrollToPayment} className="w-full mt-6">
                    Get my plan
                </Button>
                <MoneyBackGuarantee/>
                <div ref={paymentSectionRef}>
                    <PaymentSection/>
                </div>
            </div>
        </div>
    );
}

export function Timer() {
    const [time, setTime] = useState({minutes: 5, seconds: 0});

    useEffect(() => {
        const timer = setInterval(() => {
            setTime((prevTime) => {
                if (prevTime.minutes === 0 && prevTime.seconds === 0) {
                    clearInterval(timer);
                    return prevTime;
                }

                if (prevTime.seconds === 0) {
                    return {
                        minutes: prevTime.minutes - 1,
                        seconds: 59,
                    };
                }

                return {
                    ...prevTime,
                    seconds: prevTime.seconds - 1,
                };
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <span className="font-bold">
      {time.minutes}:{time.seconds.toString().padStart(2, "0")}
    </span>
    );
}
